import React from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchUserReliability } from "../../../services/api/user";

const Reliability = () => {
  const { id: userId } = useParams();
  const {
    data: reliabilityData,
    isPending: isReliabilityApiLoading,
    error: isReliabilityApiError,
  } = useQuery({
    queryKey: ["cancellationRate", userId],
    queryFn: () => fetchUserReliability(userId),
    enabled: !!userId,
  });
  return (
    <BaseCard className="py-2 px-8 sm:px-10 rounded-lg" elevation={1}>
      <div className="bg-light -mx-4 px-4 py-2 mt-2 mb-4 rounded-md flex justify-between items-center">
        <h6 className="text-dark font-normal">Reliability</h6>
      </div>

      <div className="grid grid-cols-2 gap-x-12">
        <BaseCard className="py-5 px-4 mt-2 rounded-lg lg:col-span-1 col-span-2" elevation={1}>
          <div className="flex">
            <i className="fa-solid fa-clock-rotate-left text-primary"></i>
            <div className="flex items-center w-full">
              <div className="ml-4 w-full">
                <div className="flex items-center ">
                  <p className="font-normal">Timeliness Rate (≥ 90% target)</p>
                  <div className="border-t border-dotted border-gray-500 flex-grow mx-6"></div>
                  <p className="font-normal">{reliabilityData?.data?.timelinessRate}%</p>
                </div>
                <p>
                  {reliabilityData?.data?.totalCheckedIn - reliabilityData?.data?.totalLate} of last{" "}
                  {reliabilityData?.data?.totalCheckedIn} work orders checked in on-time
                </p>
                {/* <p className="text-primary">See Check-in Details</p> */}
              </div>
            </div>
          </div>
        </BaseCard>
        <BaseCard className="py-5 px-4 mt-2 rounded-lg lg:col-span-1 col-span-2" elevation={1}>
          <div className="flex">
            <i className="fa-regular fa-circle-xmark text-primary"></i>
            <div className="flex items-center w-full">
              <div className="ml-3 w-full">
                <div className="flex items-center ">
                  <p className="font-normal">Cancellation Rate (≤ 5% target)</p>
                  <div className="border-t border-dotted border-gray-500 flex-grow mx-6"></div>
                  <p className="font-normal">{reliabilityData?.data?.cancellationRate}%</p>
                </div>
                <p>
                  {reliabilityData?.data?.totalCancelled} cancellations of last{" "}
                  {reliabilityData?.data?.totalAssigned} assigned work orders
                </p>
                {/* <p className="text-primary">See cancellations / removals</p> */}
              </div>
            </div>
          </div>
        </BaseCard>
      </div>
    </BaseCard>
  );
};

export default Reliability;
